function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\xCDbu\xF0-detail",
  transform: "translate(-1191.000000, -1129.000000)",
  fill: "#88949D",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "bed.1.3",
  transform: "translate(1191.000000, 1129.000000)"
}, React.createElement("path", {
  d: "M22,7.551 L22,3 C22,1.622 20.878,0.5 19.5,0.5 L4.5,0.5 C3.122,0.5 2,1.622 2,3 L2,7.551 C0.861,7.783 0,8.793 0,10 L0,13 L0,15 L0,17 C0,17.276 0.224,17.5 0.5,17.5 C0.776,17.5 1,17.276 1,17 L1,15.5 L23,15.5 L23,17 C23,17.276 23.224,17.5 23.5,17.5 C23.776,17.5 24,17.276 24,17 L24,15 L24,13 L24,10 C24,8.793 23.139,7.783 22,7.551 Z M3,3 C3,2.173 3.673,1.5 4.5,1.5 L19.5,1.5 C20.327,1.5 21,2.173 21,3 L21,7.5 L19.624,7.5 C19.722,7.225 19.747,6.928 19.674,6.636 L19.174,4.636 C19.007,3.967 18.408,3.5 17.719,3.5 L14.5,3.5 C13.673,3.5 13,4.173 13,5 L13,7 C13,7.176 13.036,7.343 13.092,7.5 L10.908,7.5 C10.964,7.343 11,7.176 11,7 L11,5 C11,4.173 10.327,3.5 9.5,3.5 L6.281,3.5 C5.592,3.5 4.993,3.968 4.826,4.636 L4.326,6.636 C4.253,6.928 4.278,7.225 4.376,7.5 L3,7.5 L3,3 Z M14,7 L14,5 C14,4.724 14.224,4.5 14.5,4.5 L17.719,4.5 C17.949,4.5 18.148,4.656 18.204,4.879 L18.704,6.879 C18.742,7.029 18.709,7.186 18.613,7.308 C18.518,7.43 18.374,7.5 18.219,7.5 L14.5,7.5 C14.224,7.5 14,7.276 14,7 Z M5.295,6.878 L5.795,4.878 C5.852,4.656 6.051,4.5 6.28,4.499 L9.499,4.499 C9.775,4.499 9.999,4.723 9.999,4.999 L9.999,6.999 C9.999,7.275 9.775,7.499 9.499,7.499 L5.78,7.499 C5.625,7.499 5.481,7.429 5.386,7.307 C5.291,7.185 5.257,7.028 5.295,6.878 Z M1,10 C1,9.173 1.673,8.5 2.5,8.5 L5.781,8.5 L9.5,8.5 L14.5,8.5 L18.219,8.5 L21.5,8.5 C22.327,8.5 23,9.173 23,10 L23,12.5 L1,12.5 L1,10 Z M1,13.5 L23,13.5 L23,14.5 L1,14.5 L1,13.5 Z",
  id: "Shape"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "24px",
    height: "18px",
    viewBox: "0 0 24 18",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/bed.9f757133.svg";
export { SvgComponent as ReactComponent };